export default class TourRadioOptions {
  constructor() {
    this.errorMessageId = 'nhs_ErrorForTourOption';
    this.idContactOneOnOne = 'contact-1-1';
    this.errorCssClass = 'error';
    this.idVideoChat = 'contact-vid-chat';
    this.radioChecked = '[name="leadAction"]:checked';

    this.inputContactOneOne = `<input type="radio" id="${this.idContactOneOnOne}" name="leadAction" 
    value="ra" required checked />`;
    this.labelContactOneOne = `<label for="${this.idContactOneOnOne}">1-on-1</label>`;
    
    this.inputVideoChat = `<input type="radio" id="${this.idVideoChat}" name="leadAction" 
    value="rva" required />`;
    this.labelVideoChat = `<label for="${this.idVideoChat}">Remote Video Chat</label>`;

    this.error = `<span id="${this.errorMessageId}" class="form__error" data-error-message=""
                    data-required-message="Please select one tour option" hidden>
                    Please select one tour option
                  </span>`;
  }

  getHtml() {
    return `<div class="tour__option flex--row gap--24">
      <div class="field--radio">${this.inputContactOneOne}${this.labelContactOneOne}</div>
      <div class="field--radio">${this.inputVideoChat}${this.labelVideoChat}</div>
      </div>${this.error}`;
  }

  getCheckedNode() {
    return document.querySelector(this.radioChecked);
  }

  getVideoChatLabelNode() {
    return document.querySelector(`[for="${this.idVideoChat}"]`);
  }

  getOneOnOnetLabelNode() {
    return document.querySelector(`[for="${this.idContactOneOnOne}"]`);
  }

  setInvalidState(node) {
    const errorMessage = document.getElementById(this.errorMessageId);

    node.setAttribute('aria-invalid', true);
    node.classList.add(this.errorCssClass);
    errorMessage.removeAttribute('hidden');
  }

  setValidState(node) {
    const errorMessage = document.getElementById(this.errorMessageId);

    node.removeAttribute('aria-invalid');
    node.classList.remove(this.errorCssClass);
    errorMessage.setAttribute('hidden', true);
  }

  validate() {
    return new Promise((resolve) => {
      const node = this.getCheckedNode();
      const isValid = !!node;
      const nodeVideoChat = this.getVideoChatLabelNode();
      const nodeOneOnOne = this.getOneOnOnetLabelNode();
  
      if (isValid) {
        this.setValidState(nodeVideoChat);
        this.setValidState(nodeOneOnOne);
        resolve(true);
      } else {
        this.setInvalidState(nodeVideoChat);
        this.setInvalidState(nodeOneOnOne);
        resolve(false);
      }
    });
  }
}
